import { useEffect, useRef, useMemo, useState } from 'react';
import { useLocation, useParams, useNavigate } from 'react-router';
import {useDebounceFn, useMemoizedFn} from 'ahooks';
import global from '@/utils/global';
import Bus from '@/utils/bus';
import AIContant from '@/utils/aiContant';
import { IClearHighlightPayload, IDeleteNotePayload, ISaveAnswerHandle, IUpdatePanel, IhightLightItem } from '@/utils/ctype';
import { logCount, logError, logInfo } from '@/utils/logger/arms-config';
import { login } from '@/utils/login';
import {useAppSelector} from '@/stores/index';
import { useAppDispatch } from '@/stores/index';
import {getReadingAsync, getAnswerListAsync, setPanelDataByIndex, setFocusIndex, saveAnswer,
  saveHighlightData, updateTimeState, updateRecordId, saveAnswerListAsync,
  submitAnswerAsync, toggleShowNotePanel, clearHightLightInfo, updatePanelInfo, setShowDragFiled,
  getReadingFeedbackAsync, deleteNote} from '@/stores/slice/reading';
import { getStudentInfoAsync } from '@/stores/slice/user';
import { getExamInfoAsync } from '@/stores/slice/exam';
import NotePanel from '../../components/NotePanel';
import Bottom from '../../components/Bottom';
import Main from '../../components/Main';
import { AIPanel } from '../../components/AIPanel';
import Loading from '../../components/Loading';
import MainContentAI from './MainContentAI';
import MainContent from './MainContent';
import style from './index.module.less';

export default function MockListening() {

  global.subject = 'read';

  const location = useLocation();
  const params = useParams();
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const isAI = location.pathname.indexOf('mockreadingai') > -1;
  const {showNotePanel, answerAll, answerMap, limits, currentFocus, pageDataIndex, loadAnswered, pageDataCache, highLightInfo, surplus_time, recordId, showDragField, resultMap} = useAppSelector(state => state.reading);
  const currentPapeId = useAppSelector(state => state.reading.pageData?.question.paper_id);
  const status = useAppSelector(state => state.exam.info?.reading.status);

  const isLogin = useAppSelector(state => state.user.userPermission.isLogin);
  const inited = useAppSelector(state => state.user.inited);
  const isVip = useAppSelector(state => state.user.userPermission.isVip);
  const displayAnswerMap = useAppSelector(state => state.listening.displayAnswerMap);
  const routeRecordId = Number(params.recordId);
  const [loadedRecordId, setLoadedRecordId] = useState<number | null>(null);
  const draftLoaded = loadedRecordId === routeRecordId;

  useEffect(() => {
    if (inited && !isLogin) {
      login();
    }
  }, [isLogin, inited]);

  useEffect(() => {
    console.log('页面前置检查', 'isAI:', isAI, 'status:', status);
    if (status === 3) {
      // 当前不应该打开页面
      console.log('跳回开始页');
      navigate(`/mockstart/${recordId}`);
      return;
    }

    if (isAI && (status === 1 || status === 2)) {
      console.log('跳回做题页');
      navigate(`/mockreading/${recordId}`);
      return;
    }
    if (!isAI && status === 4) {
      console.log('跳回答案页');
      navigate(`/mockreadingai/${recordId}`);
      return;
    }
  }, [isAI, status]);


  useEffect(() => {
    dispatch(updateRecordId(routeRecordId));
  }, [dispatch, routeRecordId]);

  useEffect(() => {
    if (!isAI && draftLoaded) {
      const timer = setInterval(() => {
        dispatch(saveAnswerListAsync());
      }, 10000);
      return () => {
        clearInterval(timer);
      };
    }
  }, [draftLoaded, isAI, dispatch]);

  const { run, cancel, flush } = useDebounceFn(() => {
    if (draftLoaded) {
      dispatch(saveAnswerListAsync());
    }
  }, { wait: 1500, });
  useEffect(() => cancel, [cancel, routeRecordId]);
  
  useEffect(() => {
    let active = true;
    setLoadedRecordId(null);
    // 获取数据
    const answerRequest = dispatch(getAnswerListAsync({record_id: routeRecordId}));
    const contentRequest = dispatch(getReadingAsync({record_id: routeRecordId}));
    void Promise.all([answerRequest.unwrap(), contentRequest.unwrap()])
      .then(() => {
        if (active) {
          setLoadedRecordId(routeRecordId);
        }
      })
      .catch(() => undefined);
    dispatch(getExamInfoAsync({record_id: routeRecordId}));
    if (isAI) {
      dispatch(getReadingFeedbackAsync({record_id: routeRecordId}));
      dispatch(getStudentInfoAsync());
    }
    return () => {
      active = false;
      answerRequest.abort();
      contentRequest.abort();
    };
  }, [dispatch, isAI, routeRecordId]);

  const setPanelHandle = (index: number) => {
    dispatch(setPanelDataByIndex({index}));
    if (isAI){
      Bus.publish(AIContant.AUDIO_STOP, undefined);
    }
  };

  const setFocusIndexHandle = (index: number) => {
    dispatch(setFocusIndex({index}));
  };

  const saveAnswerHandle: ISaveAnswerHandle = (index, value) => {
    if (!draftLoaded) {
      return;
    }
    if (Array.isArray(index) && Array.isArray(value)) {
      dispatch(saveAnswer({index, value}));
    } else if (!Array.isArray(index) && !Array.isArray(value)){
      dispatch(saveAnswer({index, value}));
    }
    run();
  };

  const saveHighlightDataHandle =(params: {show: boolean;wrapUid: string;} & IhightLightItem) => {
    if (!draftLoaded) {
      return;
    }
    dispatch(saveHighlightData(params));
    run();
  };

  const updateTimeHandle = (value: number) => {
    dispatch(updateTimeState(value));
  };

  // const isSubmit = useRef<boolean>(false);
  const [showLoading, setShowloading ] = useState(false);

  const submitHandle = useMemoizedFn((callback: () => void ) => {
    if (!draftLoaded) {
      return;
    }
    logCount('Submit_Answer_Reading_P1');
    logInfo({ submit: `Submit_Answer_Reading_State: showLoading${showLoading}`});

    if (showLoading) {
      console.log('[正在提交中。。。]');
      return;
    }
    logCount('Submit_Answer_Reading_P2');
    setShowloading(true);
    dispatch(saveAnswerListAsync()).then((res) => {
      logCount('Submit_Answer_Reading_P3');
      if ((res?.payload as {id: number;})?.id !== undefined) {
        dispatch(submitAnswerAsync()).then((res2) => {
          logCount('Submit_Answer_Reading_P4');
          setShowloading(false);
          if (res2?.payload) {
            logCount('Submit_Answer_Reading_P5');
            callback();
            navigate(`/mockstart/${recordId}`, {replace: true});
          }
          // isSubmit.current = false;
        }).catch(err => {
          logError(err);
          logCount('Submit_Answer_Reading_P6');
          setShowloading(false);
          // isSubmit.current = false;
        });
      }
    }).catch(err => {
      logCount('Submit_Answer_Reading_P7');
      logError(err);
      setShowloading(false);
      // isSubmit.current = false;
    });
  });

  const noteHandle = () => {
    dispatch(toggleShowNotePanel());
  };

  const clearDialogHandle= (payload?: IClearHighlightPayload) => {
    if (!draftLoaded) {
      return;
    }
    dispatch(clearHightLightInfo(payload));
    run();
  };

  const updateDialogInfo = (info:IUpdatePanel) => {
    if (!draftLoaded) {
      return;
    }
    dispatch(updatePanelInfo(info));
    run();
    flush();
  };

  const deleteNoteHandle = (payload: IDeleteNotePayload) => {
    if (!draftLoaded) {
      return;
    }
    dispatch(deleteNote(payload));
    run();
  };

  const aiContent = useMemo(() => {
    return <AIPanel paper_id={currentPapeId} course="r" />;
  }, [currentPapeId]);

  const setShowDragFieldHandle = (val: boolean) => {
    dispatch(setShowDragFiled(val));
  };


  return (
    <div className={style.viewBox}>
      <Main course="r" pageData={pageDataCache[pageDataIndex]} highLightObj={highLightInfo[pageDataIndex]}
        time={surplus_time} isAI={isAI} saveHighlightDataHandle={saveHighlightDataHandle}
        loadAnswered={loadAnswered}
        updateTimeHandle={updateTimeHandle} submitHandle={submitHandle} clearDialogHandle={clearDialogHandle}
        noteHandle={noteHandle} showNotePanel={showNotePanel} aiContent={aiContent}
        notePanel={<NotePanel showNotePanel={showNotePanel} highLightInfo={highLightInfo} noteHandle={noteHandle}
          updateNoteHandle={updateDialogInfo} deleteNoteHandle={deleteNoteHandle}></NotePanel>}>
        {
          pageDataCache.map((pageDataItem, index: number) => {
            return (
              pageDataItem ? isAI ? 
                <MainContentAI key={index} question={pageDataItem.question.question} currentFocus={currentFocus}
                  saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} pageData={pageDataItem}
                  displayAnswerMap={displayAnswerMap}
                  loadAnswered={loadAnswered} isAI={isAI} index={index} 
                  boxStyle={{display: pageDataIndex === index ? '' : 'none'}}
                  setShowDragFieldHandle={setShowDragFieldHandle} showDragField={showDragField} feedback={resultMap}></MainContentAI> : 
                <MainContent key={index} question={pageDataItem.question.question} currentFocus={currentFocus}
                  displayAnswerMap={displayAnswerMap}
                  saveAnswerHandle={saveAnswerHandle} answerMap={answerMap} pageData={pageDataItem}
                  loadAnswered={loadAnswered} isAI={isAI} index={index}
                  boxStyle={{display: pageDataIndex === index ? '' : 'none'}}
                  setShowDragFieldHandle={setShowDragFieldHandle} showDragField={showDragField}
                  setFocusIndexHandle={setFocusIndexHandle}></MainContent>
                : null
            );
          })
        }
      </Main>
      <Bottom limits={limits} answerAll={answerAll} currentFocus={currentFocus} setPanelHandle={setPanelHandle} pageDataIndex={pageDataIndex} setFocusIndexHandle={setFocusIndexHandle} showNotePanel={showNotePanel}></Bottom>
      <Loading show={showLoading}></Loading>
    </div>
  );
}
